export default {
      id: "i-analytic-services-01-usage",
      viewBox: "0 0 148 110",
      url: __webpack_public_path__ + "img/sprite.svg#i-analytic-services-01",
      toString: function () {
        return this.url;
      }
    }